import React, { useEffect, useState } from "react";
import useAccommodationState from "./useAccommodationState.ts";
import Accommodation from "./Accommodation.ts";

interface AccommodationIconProps {
    token: string;
    id: number;
    //onCancel: () => void;
}

export const AccommodationIcon: React.FC<AccommodationIconProps> = ({
    token,
    id,
}) => {
    const [item, setItem] = useState<Accommodation | null>(null);
    const { accommodation, getAccommodation } = useAccommodationState();
    useEffect(() => {
        if (token) getAccommodation(token, id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        if (accommodation) {
            setItem(accommodation);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accommodation]);

    return (
        <>
            {item ? (
                <div
                    style={{ backgroundColor: "#" + item.color }}
                    className="acc_icon"
                >
                    {item.short_name}
                </div>
            ) : null}
        </>
    );
};
